import {
	Checkbox,
	CurrencyDisplay,
	MaterialIcons,
} from '@monthio/react-components'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import {
	BottomTextAction,
	CheckboxAndTextWrapper,
	Container,
	MissingInfoInputWrapperDiv,
	OptionWrapper,
	StyledBodyFlow,
} from '../styledMissingBudgetInfoComponents'
import { MissingInfoInput } from './MissingInfoInput'
import { H2Flow } from '@monthio/react-components/dist/Typography/TypographyFlow/TypographyFlow'
import { BudgetKeyWithPossibleRentIncluded } from '../missingBudgetInfoUtils'
import { budgetEstimatesCalculatorService } from '../../BudgetOverview/budgetEstimatesCalculatorService'

export const MissingRentOptions = ({
	options,
	budgetEstimates,
}: {
	options: BudgetKeyWithPossibleRentIncluded[]
	budgetEstimates: any
}) => {
	const { t } = useTranslation()

	const [checkedOption, setCheckedOption] = useState<
		BudgetKeyWithPossibleRentIncluded | undefined
	>(undefined)

	const budgetKey = 'tree.expenses.housing.rent'

	useEffect(() => {
		budgetEstimatesCalculatorService.update(
			'insights.isRentIncludedInExpensesOthersAdditionalFixed',
			checkedOption === 'additionalFixed',
		)
		budgetEstimatesCalculatorService.update(
			'insights.isRentIncludedInExpensesOthersUncategorizedPaymentServices',
			checkedOption === 'uncategorizedPaymentServices',
		)
		if (checkedOption !== 'rentIsNotIncludedInOtherExpenses') {
			budgetEstimatesCalculatorService.update('tree.expenses.housing.rent', 0)
		}
	}, [checkedOption])

	return (
		<Container>
			<H2Flow>
				{t('miniBudgetFormV2-missingInfo-options-expensesHousingRent-header')}
			</H2Flow>
			{checkedOption !== 'rentIsNotIncludedInOtherExpenses' ? (
				options.map((option) => (
					<OptionWrapper
						$checked={checkedOption === option}
						onClick={() =>
							setCheckedOption((prev) => (prev === option ? undefined : option))
						}
						key={`INCLUDED_IN_RENT_OPTION::${option}`}
					>
						<CheckboxAndTextWrapper>
							<Checkbox
								icon={<MaterialIcons.RadioButtonUnchecked />}
								checkedIcon={<MaterialIcons.RadioButtonChecked />}
								size="small"
								color="primary"
								checked={checkedOption === option}
								onChange={(_, checked) =>
									setCheckedOption(checked ? option : undefined)
								}
							/>
							<StyledBodyFlow>
								{t(`miniBudgetFormV2-missingInfo-options-${option}Option-text`)}
							</StyledBodyFlow>
						</CheckboxAndTextWrapper>
						<CurrencyDisplay
							amount={budgetEstimates.tree.expenses.others[option]}
						/>
					</OptionWrapper>
				))
			) : (
				<MissingInfoInputWrapperDiv>
					<MissingInfoInput budgetKey={budgetKey} />
				</MissingInfoInputWrapperDiv>
			)}
			<BottomTextAction
				$clicked={checkedOption === 'rentIsNotIncludedInOtherExpenses'}
				onClick={() => {
					setCheckedOption((prev) =>
						prev !== 'rentIsNotIncludedInOtherExpenses'
							? 'rentIsNotIncludedInOtherExpenses'
							: undefined,
					)
				}}
			>
				{t('miniBudgetFormV2-noRentModal-button')}
			</BottomTextAction>
		</Container>
	)
}

// miniBudgetFormV2-missingInfo-options-additionalFixedOption-text
// miniBudgetFormV2-missingInfo-options-uncategorizedPaymentServicesOption-text
